/** HOC de disponibilidad de la API: si apiCheck es falso renderiza una pantalla 500 de servicio no disponible, si no renderiza el componente envuelto. */
import React, { useState, useEffect } from "react";
import { Layout, Typography } from "antd";
import "./apicheck.css";

const WithApiCheck = (WrappedComponent: React.ComponentType, apiCheck: boolean) => {
  return function ApiCheckComponent(props: Record<string, unknown>) {
    const [apiAvailable, setApiAvailable] = useState(true);

    useEffect(() => {
      if (apiCheck) {
        setApiAvailable(true);
      } else {
        setApiAvailable(false);
      }
    }, []);

    if (!apiAvailable) {
      return (
        <div className="app-container">
          <div className="main-content">
            <div className="api-check-wrapper">
              <Typography.Text strong className="main-text">
                500
              </Typography.Text>
              <div className="bottom-wrapper">
                <Typography.Title level={5}>
                  El servicio no está disponible, intentelo nuevamente más tarde.
                </Typography.Title>
              </div>
            </div>
          </div>
          <Layout.Footer style={{ textAlign: "center" }}>
            <Typography.Text type="secondary" style={{ fontSize: "12px" }}>
              © {new Date().getFullYear()} Innercor Soluciones ERP
            </Typography.Text>
          </Layout.Footer>
        </div>
      );
    }

    return <WrappedComponent {...props} />;
  };
};

export default WithApiCheck;
